'use client'; // Error components must be Client Components

import {
  BasicCard,
  BasicCardActions,
  BasicCardContent,
  BasicCardHeader,
  BasicCardTitle,
  Typography,
} from '@mcdougald/ui/src';
import { type ReactNode } from 'react';

export default function PageErrorComponent({
  title,
  error,
  reset,
}: Readonly<{
  title?: string;
  error: Error & { digest?: string };
  reset?: () => void;
}>): ReactNode {
  return (
    <div className={'container mt-30 mb-20'}>
      <BasicCard
        variant={'filled'}
        className={'w-[600px] mx-auto bg-red-900/50 border-red-900/20'}
      >
        <BasicCardHeader>
          <BasicCardTitle className={'text-2xl'}>
            {title ?? 'Something went wrong!'}
          </BasicCardTitle>
        </BasicCardHeader>

        <BasicCardContent>
          <Typography variant={'lg'}>Message</Typography>
          <Typography variant={'base'}>{error.message}</Typography>

          <Typography variant={'lg'} className={'mt-3'}>
            Cause
          </Typography>
          <Typography variant={'base'}>
            {error.cause ? JSON.stringify(error.cause) : 'Unknown'}
          </Typography>

          <Typography variant={'lg'} className={'mt-3'}>
            Digest
          </Typography>
          <Typography variant={'base'}>{error.digest ?? 'Unknown'}</Typography>

          <Typography variant={'lg'} className={'mt-3'}>
            Error Stack
          </Typography>
          <Typography
            variant={'xs'}
            className={
              'max-h-[300px] w-full overflow-y-scroll bg-red-800/50 p-2 break-words'
            }
          >
            {error.stack}
          </Typography>
        </BasicCardContent>

        {reset ? (
          <BasicCardActions>
            <button
              onClick={
                // Attempt to recover by trying to re-render the segment
                () => reset()
              }
              type={'button'}
              // variant={'primary'}
            >
              Try again
            </button>
          </BasicCardActions>
        ) : null}
      </BasicCard>
    </div>
  );
}
